package `data`.db.delight

import kotlin.Long
import kotlin.String

public data class FavoriteVideo(
  public val id: Long,
  public val imdbId: String?,
  public val imageUrl: String?,
  public val title: String?,
  public val isTvShow: Long,
  public val isDeleted: Long,
  public val changedAt: String?,
)
